import React from 'react';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';

const Context = React.createContext<PiralContext>({} as any);

export interface PiralContext {
	piletApi: PiletApi;
}

interface PiralContextProviderProps extends PiralContext {
	children: React.ReactNode;
}

export function PiralContextProvider(props: PiralContextProviderProps) {
	return (
		<Context.Provider
			value={{
				piletApi: props.piletApi,
			}}
		>
			{props.children}
		</Context.Provider>
	);
}

export const usePiralContext = () => React.useContext(Context);
